<script>
  import Icon from "./Icon.svelte";
  import { topFourDepartments } from "@stores/userData.js";
</script>

<div class="shareable-card">
  <h1>
    In FY23, I want more funding for <br /><strong>these departments:</strong>
  </h1>
  <div class="four-grid">
    {#each $topFourDepartments as department}
      <div class="item">
        <Icon src="{department.Department}.png" styles="max-width: 55%;" />
        <h2>{department.Department}</h2>
      </div>
    {/each}
  </div>

  <span class="shareable-card-footer"
    >Make your voice heard at <strong>houstonbudget.cool</strong></span
  >
</div>

<style>
  h1 {
    position: absolute;
    width: 100%;
    top: 7%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 5vw;
    font-weight: 200;
    line-height: 1.075;
    text-align: center;
  }

  .four-grid {
    display: flex;
    position: absolute;
    left: 0;
    top: 60%;
    transform: translateY(-50%);
    flex-direction: row;
    justify-content: center;
    place-items: center;
    width: 100%;
    align-items: stretch;
  }

  .item {
    flex: 1;
    display: flex;
    place-items: center;
    justify-content: space-between;
    flex-direction: column;
  }

  h2 {
    font-weight: 200;
    font-size: 2.5vw;
    padding: 0.25vw;
    text-align: center;
    line-height: 1.15;
    margin-top: 1.5vw;
    height: 100%;
  }
</style>
